/**
 * THIS FILE IS AUTO-GENERATED. DO NOT EDIT MANUALLY.
 * Generated from ../../api/openapi.json
 * Generated by generate-view-queries.ts
 * To regenerate, run the following command in the frontend folder:
 *    pnpm run generate:integration
 * Contact the Core Team if any issues arise.
 */

import { QueryKey, queryOptions, useQuery, UseQueryOptions } from '@tanstack/react-query'

import { handleApiRequest } from '../hooks/tanstack-query/shared/apiWrapper'
import { baseClient } from './api-client'
import { operations } from './api-types.generated'

export type ViewQueryOptions<TQueryFnData, TData = TQueryFnData, TQueryKey extends QueryKey = QueryKey> = Omit<
    UseQueryOptions<TQueryFnData, Error, TData, TQueryKey>,
    'queryKey' | 'queryFn' | 'queryKeyHashFn'
>

async function requireViewData<T>(request: Promise<T | undefined>): Promise<T> {
    const data = await request
    if (data === undefined) throw new Error('View query returned no response data')
    return data
}

/**
 * Get Activity Logs Per Day
 * 
 * Get daily activity log statistics for a given time window.

Returns the count of activity logs created per day across all activity log types.
 */
type ActivityLogsPerDayQueryData = operations['get_activity_logs_per_day_statistics_activity_logs_per_day_get']['responses'][200]['content']['application/json']

const getActivityLogsPerDayQueryKey = (queryParams: operations['get_activity_logs_per_day_statistics_activity_logs_per_day_get']['parameters']['query']) =>
    ['view', 'ActivityLogsPerDay', queryParams] as const
type ActivityLogsPerDayQueryKey = ReturnType<typeof getActivityLogsPerDayQueryKey>

export const getActivityLogsPerDayQueryOptions = <TData = ActivityLogsPerDayQueryData>(
    queryParams: operations['get_activity_logs_per_day_statistics_activity_logs_per_day_get']['parameters']['query'],
    options?: ViewQueryOptions<ActivityLogsPerDayQueryData, TData, ActivityLogsPerDayQueryKey>
) =>
    queryOptions({
        ...options,
        queryKey: getActivityLogsPerDayQueryKey(queryParams),
        queryFn: ({ signal }) =>
            requireViewData(
                handleApiRequest({ apiCall: () => baseClient.GET('/statistics/activity-logs-per-day', { params: { query: queryParams }, signal }) })
            ),
    })

export const useActivityLogsPerDay = <TData = ActivityLogsPerDayQueryData>(
    queryParams: operations['get_activity_logs_per_day_statistics_activity_logs_per_day_get']['parameters']['query'],
    options?: ViewQueryOptions<ActivityLogsPerDayQueryData, TData, ActivityLogsPerDayQueryKey>
) => useQuery(getActivityLogsPerDayQueryOptions(queryParams, options))

export const viewQueryInvalidationMap: Record<string, string[]> = {
    ActivityLogsPerDay: ['location_schedule_activity_log', 'practitioner_schedule_location_activity_log', 'practitioner_schedule_status_activity_log'],
}
